<div class="main container">
    <div class="page-header">
        <h1>{{LOCALIZATION.upload}}</h1>
    </div>
    <div class="row uploadContainer" *ngIf="uploadOn" style="padding:2em">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-12" [ngClass]="{'flex-1-5': (uploadSide && !isMobile), 'col-sm-offset-2': (!uploadSide || isMobile), 'col-md-offset-2': (!uploadSide || isMobile)}">
            <div class="panel z-depth-1">
                <div class="panel-heading text-center"><div class="lead">{{LOCALIZATION.uploadDataOptions}}</div></div>
                <div class="panel-body z-depth-2">
                    <div class="row">
                        <div class="col-xs-12 col-sm-6" style="padding-bottom: 23px;">
                            <p id="libraryLabel" class="form-label">{{LOCALIZATION.library}} <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'The library to upload to.'"></i> </p>
                            <select type="text" (change)="loadSchemaFields()" class="form-control" [(ngModel)]="input.library" name="librarySelect" aria-labelledby="libraryLabel">
                                <option *ngFor="let library of libraries; let i = index" [value]="library.name">{{library.displayName}}</option>
                            </select>
                        </div>
                        <div class="col-xs-12 col-sm-6" style="padding-bottom: 23px;">
                            <p id="uploadLabel" class="form-label">{{LOCALIZATION.uploadType}}  <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'Upload files individually or together as one upload. Only videos and images are allowed when choosing as one upload.'"></i> </p>
                            <select class="form-control" name="uploadtype" [(ngModel)]="input.uploadformat" aria-labelledby="uploadLabel">
                                <option value="individual">{{LOCALIZATION.uploadSeparate}}</option>
                                <option value="package">{{LOCALIZATION.uploadSingle}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
						<div class="col-xs-12 col-sm-6" style="padding-bottom: 23px;">
							<div class="toggle-switch">
								<p id="duplicatesLabel" class="form-label">{{LOCALIZATION.duplicateAllow}} <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'If enabled, the application will not reject an upload if the file is already in the system.'"></i> </p>
								<input id="skipDuplicateCheck" 
									[disabled]="!input.skipDuplicateCheckEnabled" [ngClass]="{disabled: !input.skipDuplicateCheckEnabled}" 
									class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox"
									[(ngModel)]="input.skipDuplicateCheck" aria-labelledby="duplicatesLabel" name="skipDuplicateCheck">
								<label for="skipDuplicateCheck"></label>
							</div>
						</div>
						<div class="col-xs-12 col-sm-6" style="padding-bottom: 23px;">
							<div class="toggle-switch">
								<p id="ocrLabel" class="form-label">{{LOCALIZATION.convertToPdf}} <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'Run the PDF conversion and OCR process on the uploaded files.'"></i> </p>
								<input id="runOCR" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="input.runOCR" name="runOCR" aria-labelledby="ocrLabel">
								<label for="runOCR"></label>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-sm-6" style="padding-bottom: 23px;">
							<p id="metadataOptsLabel" class="form-label">{{LOCALIZATION.metadataOptions}} <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'Add metadata using a template or add fields dynamically.'"></i> </p>
							<input id="attachMetadata" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="input.attachMetadata" name="attachMetadata" aria-labelledby="metadataOptsLabel">
							<label for="attachMetadata"></label>
						</div>
						<div class="col-xs-12 col-sm-6" style="padding-bottom: 23px;">
							<p id="metadataLabel" class="form-label">{{LOCALIZATION.metadataExtract}} <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'Extract metadata from file header during ingest.'"></i> </p>
							<input id="extractMetadata" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="input.extractMetadata" name="extractMetadata" aria-labelledby="metadataLabel">
							<label for="extractMetadata"></label>
						</div>
					</div>
					<div class="row" *ngIf="workflows.length > 0" style="padding-bottom: 23px;">
						<div class="col-xs-12 col-sm-6">
							<p id="workflowLabel" class="form-label">{{LOCALIZATION.workflow}} <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'Submit the uploaded contents to a business workflow.'"></i> </p>
							<select class="form-control" name="workflowSelect" aria-labelledby="workflowLabel" [(ngModel)]="input.dxWorkflow">
							    <option [ngValue]="null">-- {{ LOCALIZATION.chooseOption }} --</option>
							    <option *ngFor="let w of workflows; trackBy: trackByConfigId" [ngValue]="w">
							        {{ w.config.name }}
							    </option>
							</select>
						</div>
					</div>
					<div class="row" *ngIf="autoFiller && input.attachformat == 'template'">
						<div class="col-xs-12 col-sm-12">
						    <p class="form-label">{{LOCALIZATION.autoFill}} <i class="fa fa-question small pointMe" placement="bottom" [ngbTooltip]="'Search existing records and auto-fill the Upload form with matching record values.'"></i> </p>
							<div class="h5">{{LOCALIZATION.search}} {{autoFiller.searchFieldLabel}}</div>
						</div>
						<div class="col-xs-12 col-sm-8" style="padding-bottom: 10px;">
			                <div class="input-group">
								<input 
									type="text" class='form-control'
									id="autof_{{autoFiller.searchField}}" data-[(ngModel)]="autoFiller.value"
									placeholder=""  [attr.aria-label]="'Auto fill search field input'">
			                    <span class="input-group-btn">
			              			<button (click)='searchAutoFillCandidate(autoFiller.value, autoFiller.searchField);' class="btn btn-primary" type="button">{{LOCALIZATION.search}}</button>
			          			</span>
			                </div>
						</div>
						<div class="col-xs-12 col-sm-12">
							<div class="h5">{{LOCALIZATION.results}}: {{autoFiller.candidates ? autoFiller.candidates.length : 0}}</div>
							<div class="h5" *ngIf="autoFiller.candidates && autoFiller.candidates.length > 0">{{LOCALIZATION.title}}: {{autoFiller.candidates ? autoFiller.candidates[autoFiller.index]['title'] : ""}}</div>
						</div>						
						<div class="col-xs-12 col-sm-6" style="padding-bottom: 23px;">
							<button class="btn btn-default" type="button" (click)="prevFillCandidate()" [disabled]="!autoFiller.candidates || autoFiller.candidates && autoFiller.candidates.length == 0">{{LOCALIZATION.previous}}</button>
						    <button class="btn btn-default" type="button" (click)="nextFillCandidate()" [disabled]="!autoFiller.candidates || autoFiller.candidates && autoFiller.candidates.length == 0">{{LOCALIZATION.next}}</button>
						</div>
					</div>
					<form #kvForm="ngForm" name="kvForm">
					  <div class="row">
					    <div *ngIf="input.attachMetadata" class="col-xs-12" style="margin-bottom:16px;">
					      <div class="btn-group">
					        <label class="btn btn-primary btn-sm" [class.active]="input.attachformat === 'template'">
					          <input type="radio" name="attachformat" [(ngModel)]="input.attachformat" [value]="'template'" class="hidden-radio" /> 
					          {{ LOCALIZATION.template }}
					        </label>
					        <label class="btn btn-primary btn-sm" [class.active]="input.attachformat === 'dynamic'">
					          <input type="radio" name="attachformat" [(ngModel)]="input.attachformat" [value]="'dynamic'" class="hidden-radio" /> 
					          {{ LOCALIZATION.dynamic }}
					        </label>
					      </div>
					    </div>
						<!-- Records Management -->
						<div *ngIf="enabled.recMgmt && input.attachMetadata" class="col-xs-12 well" style="padding: 10px 0 16px 0;">
						  <div class="col-xs-12 col-sm-6">
						    <p id="rmLabel">
						      {{ LOCALIZATION.addToRM }}
						      <i class="fa fa-question small pointMe" placement="bottom" ngbTooltip="Add uploaded files as managed Records."></i>
						    </p>
						    <input
						      id="attachRMRecord"
						      class="toggle-switch-toggle toggle-switch-toggle-round"
						      type="checkbox"
						      [(ngModel)]="input.attachRMRecord"
						      aria-labelledby="rmLabel"
						      name = "attachRMRecord"
						    />
						    <label for="attachRMRecord"></label>
						  </div>
						
						  <div *ngIf="input.attachRMRecord" class="col-xs-12">
						    <h6 class="help-block">{{ LOCALIZATION.rmFilterByCategory }}</h6>
						    <ng-container *ngFor="let field of formFields">
						    <div *ngIf="field.isRMfield" class="row" style="padding-bottom: 23px;">
					        <div class="col-sm-4 col-xs-4 form-inline">
					          <span style="background-color:transparent;"><b>{{ field.title }}</b></span>
					        </div>
					        <div class="col-sm-8 col-xs-8">
					          <div *ngFor="let metadata of templateMetadata[field.name]; let i = index" [ngSwitch]="field.type">
					            <div *ngSwitchCase="'LIST'">
					              <select
					                class="form-control"
					                style="display:inline-block;"
					                [attr.aria-label]="field.title"
					                [(ngModel)]="templateMetadata[field.name][i]"
					                [id]="field.name"
					                [name]="field.name"
					                [attr.title]="field.placeholder"
					                (ngModelChange)="updateFn(field, $event)"
					                [required]="field.required"
					                [disabled]="field.readOnly">
								    <option *ngFor="let option of field.filteredOptions" [value]="option.value">
								        {{ option.name }}
								    </option>					                
					              </select>
					            </div>
					            <span *ngIf="kvForm.form.controls[field.name]?.errors?.['required']" class="required">
					              {{ LOCALIZATION.required }}.
					            </span>
					          </div>
					        </div>
						    </div>
						    </ng-container>
						
						    <!-- Existing folder select -->
						    <div class="row" style="padding-bottom: 23px;">
						      <div class="col-sm-4 col-xs-4 form-inline">
						        <span style="background-color:transparent;"><b>{{ LOCALIZATION.folderRM }}</b></span>
						      </div>
						      <div class="col-sm-8 col-xs-8">
						        <select
						          class="form-control"
						          style="display:inline-block;"
						          [attr.aria-label]="LOCALIZATION.folderRM"
						          [(ngModel)]="input.rmFields.rm_folder_select"
						          id="rm_folder_select"
						          name="rm_folder_select"
						          [attr.title]="LOCALIZATION.folderRM"
						          [disabled]="!!input.rmFields.rm_folder_input">
							          <option *ngFor="let option of rm_folders" [value]="option.id">
							            {{ option.name }}
							          </option>
						        </select>
						      </div>
						    </div>
						  </div>
						</div>
						<!-- END RM -->
						<div [hidden]="!(input.attachMetadata && input.attachformat === 'template')" class="col-xs-12">
						  <ng-container *ngFor="let field of formFields; trackBy: trackByFn">
						    <div *ngIf="(field.show === 'always' || field.show === 'upload') && !field.isRMfield"
						      class="row"
						      [ngStyle]="{ 'padding-bottom': field.ismultiple ? '15px' : '23px' }"
						    >
						    <div class="col-sm-4 col-xs-4 form-inline">
						      <span style="background-color: transparent"><b>{{ field.title }}</b></span>
						    </div>
						
						    <div class="col-sm-8 col-xs-8">
						      <div *ngFor="let metadata of templateMetadata[field.name]; let i = index; trackBy: trackByFn" [ngSwitch]="field.type">
						        <!-- String Input -->
						        <div *ngSwitchCase="'STRING'">
						          <textarea
						            *ngIf="field.name !== 'browsepath' || (field.name === 'browsepath' && !field.required)"
						            class="form-control auto-expand"
						            autoExpand
						            [(ngModel)]="templateMetadata[field.name][i]"
						            [id]="field.name"
						            [name]="field.name"
						            [attr.minlength]="field.min"
						            [attr.maxlength]="field.max"
						            [attr.placeholder]="field.placeholder"
						            [title]="field.placeholder"
						            [attr.aria-label]="field.title"
						            [disabled]="field.readOnly"
						            [required]="field.required"
						            rows="1"
						          ></textarea>
						
						          <input
						            *ngIf="field.name === 'browsepath' && field.required"
						            type="text"
						            class="item-input"
						            [(ngModel)]="templateMetadata[field.name][i]"
						            [id]="field.name"
						            [name]="field.name"
						            [attr.minlength]="field.min"
						            [attr.maxlength]="field.max"
						            [attr.placeholder]="field.placeholder"
						            [title]="field.placeholder"
						            [attr.aria-label]="field.title"
						            [disabled]="field.readOnly"
						            [required]="field.required"
						            [browsepathvalidate]="input.library"
						          />
						        </div>
						
						        <!-- Date Input -->
						        <div *ngSwitchCase="'DATE'">
						          <input
						            type="text"
						            class="item-input flatpickr template_{{field.name}}_{{i}}"
						            [id]="'daterange_' + field.name"
						            [(ngModel)]="templateMetadata[field.name][i]"
						            [name]="field.name"
						            [attr.placeholder]="field.placeholder"
						            [title]="field.placeholder"
						            [attr.aria-label]="field.title"
						            [disabled]="field.readOnly"
						            [required]="field.required"
						            datevalidate
						            (focus)="openDatePicker(field.name, field.name)"
						            (keyup.enter)="handleDateEnter('template', field.name, i)"
						          />
						          <span *ngIf="kvForm.form.controls[field.name]?.errors?.['datevalidate']" class="required">
						            {{ LOCALIZATION.dateInvalid | formatString: dateFormat }}
						          </span>
						          <span *ngIf="kvForm.form.controls[field.name]?.errors?.['datevalidateminmax']" class="required">
						            {{ LOCALIZATION.dateInvalidMinMax | formatString: 
						              datePickerOptions[field.name]?.minDate?.isValid() ? datePickerOptions[field.name].minDate.format(dateFormat) : 'Anytime' :
						              datePickerOptions[field.name]?.maxDate?.isValid() ? datePickerOptions[field.name].maxDate.format(dateFormat) : 'Anytime'
						             }}
						          </span>
						        </div>
						
						        <!-- Boolean Input (Checkbox) -->
						        <div *ngSwitchCase="'BOOLEAN'">
						          <label class="control control--checkbox">
						            <input
						              type="checkbox"
						              class="item-input"
						              [(ngModel)]="templateMetadata[field.name][i]"
						              [id]="field.name"
						              [name]="field.name"
						              [attr.placeholder]="field.placeholder"
						              [title]="field.placeholder"
						              [attr.aria-label]="field.title"
						              [disabled]="field.readOnly"
						              [required]="field.required"
						            />
						            <div class="control__indicator"></div>
						          </label>
						        </div>
						
						        <!-- Email Input -->
						        <div *ngSwitchCase="'EMAIL'">
						          <input
						            type="email"
						            class="item-input"
						            [(ngModel)]="templateMetadata[field.name][i]"
						            [id]="field.name"
						            [name]="field.name"
						            [attr.minlength]="field.min"
						            [attr.maxlength]="field.max"
						            [attr.placeholder]="field.placeholder"
						            [title]="field.placeholder"
						            [attr.aria-label]="field.title"
						            [disabled]="field.readOnly"
						            [required]="field.required"
						          />
						        </div>
						
						        <!-- Number Input -->
						        <div *ngSwitchCase="'NUMBER'">
						          <input
						            type="number"
						            class="item-input"
						            [(ngModel)]="templateMetadata[field.name][i]"
						            [id]="field.name"
						            [name]="field.name"
						            [attr.min]="field.min"
						            [attr.max]="field.max"
						            [attr.placeholder]="field.placeholder"
						            [title]="field.placeholder"
						            [attr.aria-label]="field.title"
						            [disabled]="field.readOnly"
						            [required]="field.required"
						          />
						        </div>
						        
						        <div *ngSwitchCase="'WKT'">
						          <input
						            type="text"
						            class="item-input"
						            [(ngModel)]="templateMetadata[field.name][i]"
						            [id]="field.name"
						            [name]="field.name"
						            [attr.minlength]="field.min"
						            [attr.maxlength]="field.max"
						            [attr.placeholder]="field.placeholder"
						            [title]="field.placeholder"
						            [attr.aria-label]="field.title"
						            [disabled]="field.readOnly"
						            [required]="field.required"
						          />
						        </div>						        
						
						        <!-- Dropdown List -->
						        <div *ngSwitchCase="'LIST'">
						          <select
						            class="form-control"
						            [(ngModel)]="templateMetadata[field.name][i]"
						            [id]="field.name"
						            [name]="field.name"
						            [title]="field.placeholder"
						            [attr.aria-label]="field.title"
						            (ngModelChange)="updateFn(field, $event)"
						            [required]="field.required"
						            [disabled]="field.readOnly">
							            <option *ngFor="let option of field.filteredOptions" [value]="option.value">
							              {{ option.name }}
							            </option>
						          </select>
						        </div>
						
						        <!-- Validation Messages -->
						        <span *ngIf="kvForm.form.controls[field.name]?.errors?.['required']" class="required">
						          {{ LOCALIZATION.required }}.
						        </span>
						        <span *ngIf="kvForm.form.controls[field.name]?.errors?.['browsepathvalidate']" class="required">
						          {{ LOCALIZATION.browsePathError }}.
						        </span>
						
						        <!-- Action Buttons -->
						        <i
						          *ngIf="i === 0 && field.ismultiple"
						          class="fa fa-plus pointMe accent-color"
						          style="float: right; margin: 4px 0 4px 4px"
						          aria-hidden="true"
						          (click)="appendTemplateField(field.name)"
						          title="Add field value"></i>
						        <i
						          *ngIf="i !== 0"
						          class="fa fa-trash pointMe text-red"
						          style="float: right; margin: 4px 0 4px 4px"
						          aria-hidden="true"
						          (click)="removeTemplateField(field.name, i)"
						          title="Remove field value"></i>
						        <i
						          *ngIf="!field.readOnly && field.name === 'browsepath'"
						          class="far fa-edit pointMe"
						          style="float: right; margin-top: 4px"
						          (click)="toggleBrowsepathEdit(field.name, i)"
						          title="Edit the browse path"></i>
						        <i 
							        *ngIf="!field.readOnly && field.type === 'DATE'"
							        class="fas fa-calendar-alt pointMe" 
							        style="float:right;margin-top:4px;" 
							        (click)="openDatePicker(field.name, field.name)" 
							        title="{{LOCALIZATION.openCalendar}}"></i>
						      </div>
						    </div>
						  </div>
						  </ng-container>
						  <!-- UDOCA Notifications Fields -->
						  <div *ngIf="isHandleNotifications()" class="row" style="padding-bottom: 23px">
						    <div class="col-sm-4 col-xs-4 form-inline">
						      <span style="background-color: transparent"><b>Email to</b></span>
						    </div>
						    <div class="col-sm-8 col-xs-8 form-inline">
						      <input type="text" class="item-input" id="email_notification" name="email_notification" placeholder="list of emails separated by comma" />
						      <i title="Select Email(s)" (click)="toggleEmailsEdit('email_notification')" class="far fa-edit pointMe accent-color"></i>
						    </div>
						  </div>
						  <div *ngIf="isHandleNotifications()" class="row" style="padding-bottom: 23px;">
							<div class="col-sm-4 col-xs-4 form-inline">
								<span style="background-color:transparent;"><b>Print to</b></span>
							</div>
							<div class="col-sm-8 col-xs-8 form-inline">
								<input type="text" class="item-input"
									   id="printer_notification" name="printer_notification"
									   placeholder="printer name">
							</div>
						</div>
						</div>
						
						<ng-container *ngFor="let values of appendFields | keyvalue; let key = index; trackBy: trackByFn"> 
						<div class="col-xs-12" *ngIf="input.attachMetadata && input.attachformat === 'dynamic'">
						
						  <div class="col-sm-4 col-xs-6 form-inline">
						    <select class="form-control" 
						    	(ngModelChange)="updateAppendField($event,key)" 
						    	[(ngModel)]="appendFields[key].name" 
						    	[name]="'appendField_' + key" 
						    	style="margin-bottom:10px;width:85%;"  
						    	[attr.aria-label]="'field '+key">
						      		<option *ngFor="let field of formFields; let i = index" [value]="field.name">{{field.title}}</option>
						    </select>
						    <i *ngIf="key === 0" (click)="addAppendField()" class="fa fa-plus pointMe accent-color" aria-hidden="true"></i>
						    <i *ngIf="key !== 0" (click)="removeAppendField(key)" class="fa fa-trash pointMe text-red" aria-hidden="true"></i>
						  </div>
						
						  <div class="col-sm-8 col-xs-6">
						    <div *ngFor="let value of appendFields[key].content; let i = index; trackBy: trackByFn" [ngSwitch]="appendFields[key].type">
						      
						      <!-- String Case -->
						      <div *ngSwitchCase="'STRING'">
						        <textarea class="form-control auto-expand" autoExpand [(ngModel)]="appendFields[key].content[i]" id="d_{{key}}" name="{{appendFields[key].name}}"
						                  [minlength]="appendFields[key].min" [maxlength]="appendFields[key].max" [required]="appendFields[key].required"
						                  [placeholder]="appendFields[key].placeholder ?? ''" [title]="appendFields[key].placeholder ?? ''"  [attr.aria-label]="'field '+key +' value '+i" rows="1"></textarea>
						      </div>
						
						      <!-- Date Case -->
						      <div *ngSwitchCase="'DATE'">
						        <input type="text" class="item-input flatpickr append_{{appendFields[key].name}}_{{key}}_{{i}}" id="daterange_{{key}}_{{i}}"
						               [(ngModel)]="appendFields[key].content[i]" name="{{appendFields[key].name}}" [placeholder]="appendFields[key].placeholder ?? ''"
						               [title]="appendFields[key].placeholder ?? ''"  [attr.aria-label]="'field '+key+' value '+i" [required]="appendFields[key].required"
						               datevalidate (focus)="openDatePicker(key+'_'+i, appendFields[key].name)" (keyup)="handleDateEnter('dynamic', ''+key, i)">
						        <span *ngIf="kvForm.form.controls[appendFields[key].name]?.errors?.['datevalidate']" class="required">{{ LOCALIZATION.dateInvalid | formatString: dateFormat }}</span>
						        <span *ngIf="kvForm.form.controls[appendFields[key].name]?.errors?.['datevalidateminmax']" class="required">
						          {{ LOCALIZATION.dateInvalidMinMax | formatString: 
						            (datePickerOptions[appendFields[key].name]?.minDate && datePickerOptions[appendFields[key].name].minDate.isValid() ? datePickerOptions[appendFields[key].name].minDate.format(dateFormat) : LOCALIZATION.anytime) :
						            (datePickerOptions[appendFields[key].name]?.maxDate && datePickerOptions[appendFields[key].name].maxDate.isValid() ? datePickerOptions[appendFields[key].name].maxDate.format(dateFormat) : LOCALIZATION.anytime)
						          }}
						        </span>
						      </div>
						
						      <!-- Boolean Case -->
						      <div *ngSwitchCase="'BOOLEAN'">
						        <label class="control control--checkbox">
						          <input type="checkbox" class="item-input" [(ngModel)]="appendFields[key].content[i]" id="d_{{key}}" name="{{appendFields[key].name}}"
						                 [placeholder]="appendFields[key].placeholder ?? ''" [title]="appendFields[key].placeholder ?? ''"  [attr.aria-label]="'field '+key+' value '+i" [required]="appendFields[key].required">
						          <div class="control__indicator"></div>
						        </label>
						      </div>
						
						      <!-- Email Case -->
						      <div *ngSwitchCase="'EMAIL'">
						        <input type="email" class="item-input" [(ngModel)]="appendFields[key].content[i]" id="d_{{key}}" name="{{appendFields[key].name}}"
						               [minlength]="appendFields[key].min" [maxlength]="appendFields[key].max" [placeholder]="appendFields[key].placeholder"
						               [title]="appendFields[key].placeholder ?? ''"  [attr.aria-label]="'field '+key+' value ' + i" [required]="appendFields[key].required">
						      </div>
						
						      <!-- Number Case -->
						      <div *ngSwitchCase="'NUMBER'">
						        <input type="number" class="item-input" [(ngModel)]="appendFields[key].content[i]" id="d_{{key}}" name="{{appendFields[key].name}}"
						               [min]="appendFields[key].min" [max]="appendFields[key].max" [placeholder]="appendFields[key].placeholder ?? ''"
						               [title]="appendFields[key].placeholder ?? ''"  [attr.aria-label]="'field '+ key + ' value ' + i" [required]="appendFields[key].required">
						      </div>
						
						      <!-- WKT Case -->
						      <div *ngSwitchCase="'WKT'">
						        <input type="text" class="item-input" [(ngModel)]="appendFields[key].content[i]" id="d_{{key}}" name="{{appendFields[key].name}}"
						               [minlength]="appendFields[key].min" [maxlength]="appendFields[key].max" [placeholder]="appendFields[key].placeholder ?? ''"
						               [title]="appendFields[key].placeholder ?? ''"  [attr.aria-label]="'field '+key+' value ' + i" [required]="appendFields[key].required">
						      </div>
						
						      <!-- List Case -->
						      <div *ngSwitchCase="'LIST'">
						        <select class="form-control" 
						        	style="display:inline-block;" 
						        	[(ngModel)]="appendFields[key].content[i]" 
						        	id="d_{{key}}" 
						        	name="{{appendFields[key].name}}"
						            [required]="appendFields[key].required"
						            [attr.aria-label]="'field '+key+' value ' + i">
							            <option *ngFor="let option of getFilteredOptions(appendFields[key])" [value]="option.name">
						                  {{ option.name }}
						                </option>
						        </select>
						      </div>
						
						      <span *ngIf="kvForm.form.controls[appendFields[key].name]?.errors?.['required']" class="required">{{LOCALIZATION.required}}.</span>
						      
						      <i *ngIf="i === 0" (click)="addAppendValue(key)" class="fa fa-plus pointMe accent-color" style="float:right;margin:4px 0 4px 4px;" aria-hidden="true" title="Add field value"></i>
						      <i *ngIf="i !== 0" (click)="removeAppendValue(key, i)" class="fa fa-trash pointMe text-red" style="float:right;margin:4px 0 4px 4px;" aria-hidden="true" title="Remove field value"></i>
						      <i *ngIf="appendFields[key].name === 'browsepath' && !appendFields[key].readOnly" title="Edit the browse path" (click)="toggleBrowsepathEdit(key, i)" class="far fa-edit pointMe" style="float:right;margin-top:4px;"></i>
						      <i *ngIf="appendFields[key].type === 'date' && !appendFields[key].readOnly" class="fas fa-calendar-alt pointMe" style="float:right;margin-top:4px;" (click)="openDatePicker(key+'_'+i, appendFields[key].name)" title="{{LOCALIZATION.openCalendar}}"></i>
						    </div>
						  </div>
						</div>
                        </ng-container>
					  </div>
					</form>		
					<br>
					<!-- // File upload section when the upload section is not on the side -->
					<div *ngIf="!uploadSide || isMobile">
					  <div class="dropzone background-light" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
					    <div style="flex: 1">
					      <div>
					        <p><em>{{ LOCALIZATION.dragDropRecords }}</em></p>
					      </div>
							<label 
							    for="file-upload" 
							    class="btn btn-circle btn-lg btn-primary z-depth-1" 
							    title="{{LOCALIZATION.addFile}}">
							    <i class="fa fa-file" aria-hidden="true"></i>
							</label>
							<input id="file-upload"
							       type="file" 
							       multiple
							       fileinput 
							       (filesSelected)="onFilesSelected($event)" 
							       class="hidden-input" />
					    </div>
					  </div>
					</div>
					<div *ngIf="ingestMsg && (!uploadSide || isMobile)" class="'alert alert-'+ingestMsgType" role="alert"  style="white-space:pre-wrap;">{{ingestMsg}}</div>
					<div *ngIf="(!uploadSide || isMobile) && (uploadFiles?.length ?? 0) > 0">
					<div
					    class="col-xs-12 z-depth-1"
					    *ngFor="let file of getUnprocessedFilteredFiles(); let i = index"
					    style="margin-bottom: 5px; padding: 5px; border-radius: 5px"
					  >
					    <div style="display: flex; flex-wrap: wrap">
					      <!-- Image Preview -->
					      <div style="flex: 1; text-align: center">
					        <img
					          [src]="file.currentFileSrc"
					          class="img-responsive"
					          [alt]="'Preview for ' + file.name"
					          style="max-width: 60px"
					        />
					      </div>
					
					      <!-- File Name & Size -->
					      <div style="flex: 5; text-align: center; overflow: hidden; text-overflow: ellipsis">
					        <span [title]="file.name">{{ file.name }}</span>
					        <p [title]="file.sizeStr"><em>{{ file.sizeStr }}</em></p>
					
					        <!-- Thumbnail Upload Input -->
					        <div *ngIf="file.status !== 'FAIL' && file.status !== 'SUCCESS'">
					          <span>
					            <label [for]="'thumbnailUpload' + i">{{ LOCALIZATION.chooseThumbnail }}</label>
					            <input
					              type="file"
					              [id]="'thumbnail' + i"
					              [name]="'thumbnail-upload' + i"
					              accept=".jpg, .jpeg, .png, .gif, .bmp, .webp"
					              (change)="onThumbnailSelected($event, i)"
					            />
					          </span>
					        </div>
					
					        <!-- Error Messages -->
					        <div *ngIf="file.status === 'FAIL' && (file.message?.length ?? 0)> 0 && (file.errorMessage?.length ?? 0) == 0" class="alert alert-danger" style="display: inline-block; margin-top: 12px;">
					          {{ file.message }}
					        </div>
					        <div *ngIf="(file.errorMessage?.length ?? 0) > 0" class="text-center alert alert-danger">
					          {{ file.errorMessage }}
					        </div>
					      </div>
					
					      <!-- Status & Remove Button -->
					      <div style="flex: 1">
					        <span class="alert alert-success pull-left" *ngIf="file.status === 'SUCCESS'">{{ LOCALIZATION.added }}</span>
					        <span class="alert alert-danger pull-left" *ngIf="file.status === 'FAIL'">{{ LOCALIZATION.failed }}</span>
					        <i
					          class="fa fa-times fa-1x text-red pointMe pull-right"
					          *ngIf="!uploading"
					          aria-hidden="true"
					          (click)="removeFile(i)"
					        ></i>
					      </div>
					    </div>
					
					    <!-- Loader for Pending Upload -->
					    <div *ngIf="file.status === 'PENDING'" class="loader"></div>
					  </div>
					</div>
					<div class="text-center" *ngIf="(!uploadFiles || uploadFiles.length < 1) && (!uploadSide || isMobile)"><span><em>{{LOCALIZATION.addFiles}}</em></span></div>
					<!-- // END File upload section -->
					<div class="row">
						<div class="col-xs-12" [ngClass]="{'btn-group-xs': isMobile, 'btn-group-sm': !isMobile}" style="margin-top: 15px; text-align: center;">
							<button class="btn btn-danger z-depth-1 delete " title="Reset the upload form data" [disabled]="uploading" *ngIf="input.attachMetadata" (click)="resetMetadata()">{{LOCALIZATION.clearForm}}</button>
							<button class="btn btn-danger z-depth-1 delete" title="Reset the file list" [disabled]="uploading" (click)="resetFiles()" style="margin-left:10px">{{LOCALIZATION.clearFiles}}</button>
							<button class="btn btn-primary z-depth-1" title="Perform the upload" [disabled]="uploadFiles.length < 1 || uploading || (input.attachMetadata && !kvForm.valid)" (click)="upload()" style="margin-left:10px">
								<span *ngIf="!uploading">{{LOCALIZATION.upload}}</span> <span *ngIf="uploading">{{LOCALIZATION.uploading}}...</span>
							</button>							
						</div>
					</div>
		        </div>
            </div>
        </div>
        <!--
			Upload dropzone when the Upload is on the side
		-->
		<div *ngIf="uploadSide && !isMobile" class="uploadDropzoneContainer">
		  <div>
		    <div class="dropzone background-light" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
		      <div style="flex:1">
		        <div>
		          <p><em>{{ LOCALIZATION.dragDropRecords }}</em></p>
		        </div>
					<label 
					    for="file-upload" 
					    class="btn btn-circle btn-lg btn-primary z-depth-1" 
					    title="{{LOCALIZATION.addFile}}">
					    <i class="fa fa-file" aria-hidden="true"></i>
					</label>
					<input id="file-upload"
					       type="file" 
					       multiple
					       fileinput 
					       (filesSelected)="onFilesSelected($event)" 
					       class="hidden-input" />
		      </div>
		    </div>
		  </div>
		
		  <div *ngIf="ingestMsg" class="alert alert-{{ingestMsgType}}" role="alert" style="white-space:pre-wrap;">
		    {{ ingestMsg }}
		  </div>
		
		  <div *ngIf="uploadFiles && uploadFiles.length > 0">
		    <div *ngFor="let file of getUnprocessedFilteredFiles(); let i = index" 
		         class="col-xs-12 z-depth-1" 
		         style="margin-bottom: 5px; padding: 5px; border-radius: 5px;">
		    
		      <div style="display:flex;flex-wrap:wrap">
		        <div style="flex:1;text-align:center">
		          <img [src]="file.currentFileSrc" class="img-responsive" [alt]="'Preview for ' + file.name" style="max-width:60px">
		        </div>
		        <div style="flex:5;text-align:center;overflow:hidden;text-overflow:ellipsis;">
		          <span [title]="file.name">{{ file.name }}</span>
		          <p [title]="file.sizeStr"><em>{{ file.sizeStr }}</em></p>
		
		          <div *ngIf="file.status !== 'FAIL' && file.status !== 'SUCCESS'">
		            <span>
		              <label for="thumbnailUpload">{{ LOCALIZATION.chooseThumbnail }}</label>
		              <input type="file" 
		                     [id]="'thumbnail' + i" 
		                     [name]="'thumbnail-upload' + i"
		                     accept=".jpg, .jpeg, .png, .gif, .bmp, .webp" 
		                     (change)="onThumbnailSelected($event, i)">
		            </span>
		          </div>
		
		          <div class="alert alert-danger" 
		               style="display:inline-block; margin-top:12px;" 
		               *ngIf="file.status === 'FAIL' && (file.message?.length ?? 0) > 0 && (file.errorMessage?.length ?? 0) == 0">
		            {{ file.message }}
		          </div>
		
		          <div *ngIf="(file.errorMessage?.length ?? 0) > 0" class="text-center alert alert-danger">
		            {{ file.errorMessage }}
		          </div>
		        </div>
		
		        <div style="flex:1;">
		          <span class="alert alert-success pull-left" *ngIf="file.status === 'SUCCESS'">
		            {{ LOCALIZATION.added }}
		          </span>
		          <span class="alert alert-danger pull-left" *ngIf="file.status === 'FAIL'">
		            {{ LOCALIZATION.failed }}
		          </span>
		          <i class="fa fa-times fa-1x text-red pointMe pull-right" 
		             aria-hidden="true" 
		             *ngIf="!uploading" 
		             (click)="removeFile(i)">
		          </i>
		        </div>
		      </div>
		
		      <div *ngIf="file.status === 'PENDING'" class="loader"></div>
		    </div>
		  </div>
		
		  <div class="text-center" *ngIf="!uploadFiles || uploadFiles.length < 1">
		    <span><em>{{ LOCALIZATION.addFiles }}</em></span>
		  </div>
		</div>
        <!--
			End of upload dropzone 
		-->
    </div>
</div>